import { motion } from 'framer-motion';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const result = await response.json();
      if (response.ok) {
        setMessage("Success! You've been added to our email list.");
        setEmail('');
      } else {
        setError(result.error || 'Something went wrong.');
      }
    } catch (err) {
      setError('Failed to subscribe.');
    }
  };

  const locations = [
    {
      city: 'Pune',
      street: 'Riveria Society, Mont Vert Zenith, Baner Rd',
      location: 'Baner, Pune, Maharashtra 411045',
      hours: 'Open 9 am ⋅ Closes 8 pm',
      phone: '+91 9130081345'
    }
  ];

  return (
    <footer id="footer" className="mt-0 py-5">
      <div className="container py-5">
        <div className="row justify-content-between">
          <div className="col-sm-12 col-lg-6 col-xl-6">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <img alt="Porto" height="60" src="img/mine/Gunadhya AI Logo.gif" />
              <motion.p
                className="mb-0 text-4 font-weight-medium mt-lg-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ delay: 0.25, duration: 0.5 }}
              >
                Unlock the power of artificial intelligence with our cutting-edge solutions. From predictive analytics to automation, we
                empower businesses to innovate, streamline operations, and drive growth.
              </motion.p>
            </motion.div>
          </div>
          <div className="col-sm-12 col-lg-6 col-xl-4 col-info-footer mt-4 mt-sm-5 mt-lg-2">
            <div className="row" style={{ paddingLeft: window.innerWidth <= 768 ? '0px' : '150px' }}>
              <div className="col-md-12 mt-3 mt-md-0">
                <motion.p
                  className="mb-0 p-1 text-4 font-weight-medium"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.2 }}
                  transition={{ delay: 0.15 * 0.05, duration: 0.5 }}
                >
                  <i className="far fa-envelope text-color-primary text-4 me-2"></i>
                  <NavLink to="info@gunadhyasoft.com" style={{ color: '#999' }}>
                    info@gunadhyasoft.com
                  </NavLink>
                </motion.p>
                <motion.p
                  className="mb-0  p-1 text-4 font-weight-medium"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.2 }}
                  transition={{ delay: 0.15 * 0.05, duration: 0.5 }}
                >
                  <i className="fas fa-phone text-color-primary text-4 me-md-2"></i>
                  IN: +91 9130081345
                </motion.p>
                <motion.p
                  className="mb-0  p-1 text-4 font-weight-medium"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.2 }}
                  transition={{ delay: 0.25, duration: 0.5 }}
                >
                  <i className="fas fa-phone text-color-primary text-4  me-md-2"></i> SG: +65 81912862
                </motion.p>
                <motion.p
                  className="mb-0 p-1 text-4 font-weight-medium"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.2 }}
                  transition={{ delay: 0.25, duration: 0.5 }}
                >
                  <i className="far fa-clock text-color-primary text-4 me-md-2"></i>
                  Mon - Fri 10:00am - 8:00pm
                </motion.p>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-between">
          <div className="col-sm-12 col-lg-7 col-xl-6 d-none d-sm-flex">
            <div className="nav-footer w-100 pt-5 mt-0 mt-lg-4">
              <div className="row justify-content-between">
                <div className="col-auto me-auto">
                  <div>
                    <div className="footer-nav footer-nav-links">
                      <nav>
                        <ul className="nav" id="footerNav">
                          <li>
                            <NavLink className="text-color-hover-primary font-weight-semibold custom-text-2 text-capitalize" to="/">
                              Home
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="text-color-hover-primary font-weight-semibold custom-text-2 text-capitalize"
                              to="/our-utilities"
                            >
                              Our Utilities
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="text-color-hover-primary font-weight-semibold custom-text-2 text-capitalize"
                              to="/contact-us"
                            >
                              Contact Us
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{ delay: 0.1, duration: 0.5 }}
                  >
                    <ul className="header-social-icons social-icons social-icons-clean social-icons-icon-light social-icons-big d-none d-lg-block m-0 p-relative bottom-10">
                      <li className="social-icons-instagram">
                        <NavLink to="https://www.instagram.com/gunadhyasoft" target="_blank" className="text-4" title="Instagram">
                          <i className="fab fa-instagram"></i>
                        </NavLink>
                      </li>
                      <li className="social-icons-x">
                        <NavLink
                          to="https://www.linkedin.com/company/gunadhya-software-solutions-pvt--ltd-/posts/?feedView=all"
                          target="_blank"
                          className="text-4"
                          title="Twitter"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </NavLink>
                      </li>
                      <li className="social-icons-facebook">
                        <NavLink to="https://www.facebook.com/gunadhyasoft" target="_blank" className="text-4" title="Facebook">
                          <i className="fab fa-facebook-f"></i>
                        </NavLink>
                      </li>
                    </ul>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-lg-5 col-xl-6">
            <div className="d-flex justify-content-end custom-footer-copywriting pt-5 mt-0 mt-lg-4">
              <motion.p
                className="mb-0 text-start text-lg-end d-block w-100"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ delay: 0.3, duration: 0.5 }}
              >
                Gunadhya AI. © 2025. All Rights Reserved.
              </motion.p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
